import { extendCrudApiByHousehold } from '@/utils/api.js';

const invalidatesEvents = (result, error, arg) => [
  { type: 'Events', id: arg.id, householdId: arg.householdId },
  { type: 'Events', id: 'LIST', householdId: arg.householdId },
];

const eventsApi = extendCrudApiByHousehold({
  entityNameSingular: 'Event',
  entityNamePlural: 'Events',
  entityPath: 'events',
  extraEndpoints: (builder) => ({
    updateEvent: builder.mutation({
      query: ({ householdId, id, data }) => ({
        url: `/h/${householdId}/events/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: invalidatesEvents,
    }),
    deleteEvent: builder.mutation({
      query: ({ householdId, id }) => ({
        url: `/h/${householdId}/events/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: invalidatesEvents,
    }),
    uploadEventImage: builder.mutation({
      query: ({ householdId, file }) => {
        const formData = new FormData();
        formData.append('file', file);
        return {
          url: `/h/${householdId}/events/images/upload`,
          method: 'POST',
          body: formData,
        };
      },
    }),
  }),
});

export const {
  useGetEventsQuery,
  useGetEventQuery,
  useCreateEventMutation,
  useUpdateEventMutation,
  useDeleteEventMutation,
  useUploadEventImageMutation,
} = eventsApi;
